import React from 'react'
import { Modal } from 'react-bootstrap'
import "./verifyIdentityInfo.scss"
import { useTranslation } from 'react-i18next';

interface VerifyIdentityModalProps {
  show: boolean;
  verifyIdentityModalHide: () => void;
}

const VerifyIdentityModal: React.FC<VerifyIdentityModalProps> = ({ verifyIdentityModalHide, ...props }) => {

  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      aria-labelledby="verify-identity-modal"
      centered
      onHide={verifyIdentityModalHide}
      className='verify-identity-modal'
    >
      <Modal.Header closeButton>
        <Modal.Title id="verify-identity-modal">
          {t('photo-id-list')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='videntity-data'>
          <ul>
            <li>UK {t('photo-id-list-point-one')}</li>
            <li>{t('photo-id-list-point-two')}</li>
            <li>UK {t('photo-id-list-point-three')}</li>
            <li>{t('photo-id-list-point-four')}</li>
            <li>{t('photo-id-list-point-five')}</li>
            <li>{t('photo-id-list-point-six')}</li>
          </ul>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default VerifyIdentityModal